var _circle, _circle2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserSkeleton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 382,
    height: 138,
    viewBox: "0 0 382 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 56,
    fill: "#43464C",
    fillOpacity: 0.3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 56,
    fill: "#43464C",
    fillOpacity: 0.3
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 246,
    height: 24,
    transform: "matrix(1 0 0 -1 136 52)",
    fill: "#43464C",
    fillOpacity: 0.3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 246,
    height: 24,
    transform: "matrix(1 0 0 -1 136 52)",
    fill: "#43464C",
    fillOpacity: 0.3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 246,
    height: 24,
    transform: "matrix(1 0 0 -1 136 80)",
    fill: "#43464C",
    fillOpacity: 0.3
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 246,
    height: 24,
    transform: "matrix(1 0 0 -1 136 80)",
    fill: "#43464C",
    fillOpacity: 0.3
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 246,
    height: 16,
    transform: "matrix(1 0 0 -1 136 100)",
    fill: "#43464C",
    fillOpacity: 0.3
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 246,
    height: 16,
    transform: "matrix(1 0 0 -1 136 100)",
    fill: "#43464C",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserSkeleton);
export default __webpack_public_path__ + "static/media/user_skeleton.e35383da438b7ba9dee89a75b1383404.svg";
export { ForwardRef as ReactComponent };